import { styled } from "@mui/system"
import { Box, Card, Typography } from "@mui/material"

export const ModalCard = styled(Card)({
  display: "flex",
  width: "560px",
  padding: "24px 32px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
})

export const ModalHeader = styled(Typography)({
  color: "var(--grey-grey-09)",
  fontSize: "22px",
  fontWeight: 400,
  lineHeight: "28px",
})

export const ModalTextMain = styled(Typography)({
  color: "var(--grey-grey-06)",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
})

export const CheckboxColumn = styled(Box)({})

export const CheckboxWrapper = styled(Box)({
  display: "flex",
  gap: "10px",
})

export const ButtonWrapper = styled(Box)({
  width: "100%",
  display: "flex",
  gap: "10px",
  alignItems: "flex-end",
})

export const ErrorMessage = styled(Typography)({
  color: "var(--cherry)",
})

export const Spacer = styled(Box)({
  flex: 1,
})
